import { Button } from '@blockworks/ui/button';
import { FlexBox, FlexBoxProps } from '@blockworks/ui/flex-box';

type MarkdownEditorPreviewTabsProps = {
    isPreviewing: boolean;
    setIsPreviewing: () => void;
    setIsEditing: () => void;
} & Omit<FlexBoxProps, 'children'>;

const MarkdownEditorPreviewTabs = ({
    isPreviewing,
    setIsPreviewing,
    setIsEditing,
    ...rest
}: MarkdownEditorPreviewTabsProps) => {
    return (
        <FlexBox w="full" {...rest}>
            <Button
                active={!isPreviewing}
                onClick={setIsEditing}
                size="xs"
                borderRadius="none"
                variant="ghost"
                className="rounded-t-md"
            >
                Write
            </Button>
            <Button
                active={isPreviewing}
                onClick={setIsPreviewing}
                size="xs"
                borderRadius="none"
                variant="ghost"
                className="rounded-t-md"
            >
                Preview
            </Button>
        </FlexBox>
    );
};

export { MarkdownEditorPreviewTabs };
